/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        if ($(window).width() < 768) {
          mobile_menu();
        }
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
        swiper();
        main_menu();
        init_scroll_links();
        MAP.init();
        check_hash();
        partners();
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    'template_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    'single_property': {
      init: function() {
        //main_menu();
        MAP.init();
        //scrollDownProperty();
      }
    },
    'post_type_archive_property': {
      init: function() {
        initMasonry();
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

  // custom functions

  // // Arrow
  // function arrow() {
  //
  //   $(window).scroll(function(){
  //
  //
  //
  //   });
  //
  // });

  function main_menu() {

    $( "header" ).css("backgroundColor","transparent");
    $( "header" ).css("border-bottom","none");

    //$( ".navbar .nav-primary a" ).css("color","white");

    $("#header-logo").hide();
    $(".regular-menu #header-logo img").css("transform","scale(0.5)");
    $(".regular-menu #header-logo img").css("-webkit-transform","scale(0.5)");

    var navbar_toggled = false;

    $(window).scroll(function(){

        if($(this).scrollTop()> 10){
          $(".arrow").fadeOut();
        }
        if($(this).scrollTop()< 10 ){
          $(".arrow").fadeIn();
        }

        if($(this).scrollTop()>=$('.content-wrap').position().top*0.7){
            $("#header-logo").fadeIn();
            $("#header-logo img").css("transform","scale(1.0)");
            $("#header-logo img").css("-webkit-transform","scale(1.0)");
        }
        else if ($(this).scrollTop()<=$('.content-wrap').position().top*0.7) {
            $("#header-logo").fadeOut("fast");
            $("#header-logo img").css("transform","scale(0.5)");
            $("#header-logo img").css("-webkit-transform","scale(0.5)");
        }

        if($(this).scrollTop()>=$('.top-full-section').position().top + $(window).height()*0.7 && !navbar_toggled){
          navbar_toggled = true;
          $( "header" ).animate({
            backgroundColor: "rgb( 255, 255, 255 )"
          }, 300, function() {
            // Animation complete
          });
          $( "header" ).css("border-bottom","1px solid black");
          $( ".navbar .nav-primary a" ).animate({
            color: "black"
          }, 300, function() {
            // Animation complete
          });
        }
        if($(this).scrollTop()<=$('.top-full-section').position().top + $(window).height()*0.7 && navbar_toggled){
          navbar_toggled = false;
          $( "header" ).animate({
            backgroundColor: "transparent"
          }, 300, function() {
            // Animation complete
          });
          $( "header" ).css("border-bottom","none");
          $( ".navbar .nav-primary a" ).animate({
            //color: "white"
          }, 300, function() {
            //
          });
        }
        // else if ($(this).scrollTop()<=$('.top-full-section').position().top + 10 && navbar_toggled){
        //   console.log(navbar_toggled);
        //   // $( ".navbar" ).animate({
        //   //   backgroundColor: "transparent"
        //   // }, 300, function() {
        //   //   // Animation complete
        //   // });
        //   $( ".navbar .nav-primary a" ).animate({
        //     color: "white"
        //   }, 300, function() {
        //     navbar_toggled = false;
        //   });
        // }
    });

  }

  // Mobile Menu

  function mobile_menu() {
    var mobile_menu_open = false;
    $('#nav-icon3').click(function(){
      if (!mobile_menu_open) {
        $(this).toggleClass('open');
        $(".nav-mobile").fadeIn();
        mobile_menu_open = true;
      }
      else if (mobile_menu_open) {
        $(this).toggleClass('open');
        $(".nav-mobile").fadeOut();
        mobile_menu_open = false;
      }
  	});
    $("nav li a").click(function(e) {
      if ($(this).parent().hasClass("scroll")) {
        $(".nav-mobile").fadeOut();
        $("#nav-icon3").toggleClass('open');
        mobile_menu_open = false;
      }
    });
  }

  function init_scroll_links() {
    $("nav li a").click(function(e) {
      if ($(this).parent().hasClass("scroll")) {
        // if ($(window).width() < 768) {
        //   $(".nav-mobile").fadeOut();
        // }
        // Prevent a page reload when a link is pressed
        e.preventDefault();
        // Call the scroll function
        //console.log($(this).attr("href").split("#")[1]);
        goToByScroll($(this).attr("href").split("#")[1]);

      }
    });
  }

  function scrollDownProperty() {
    $(".property-scroll").click(function(e) {
        // Prevent a page reload when a link is pressed
        console.log("click");
        e.preventDefault();
        goToByScroll("property-info-section");
    });
  }

  function goToByScroll(class){
     //Remove "link" from the ID
     //var class = id.replace("-section", "");
     var class = "."+class;
     //Scroll
     $('html,body').animate({
       scrollTop: $(class).offset().top-150},
       'slow');
  }

  function check_hash() {
		if ( window.location.hash.length > 0 ) {
			var hash = window.location.hash.slice(1);
      if ($(window).width() < 480) {
        $(".nav-mobile").fadeOut();
      }
			goToByScroll(hash);
		}
	}

  // Uthyres Slider

  function swiper() {

    var mySwiper = new Swiper ('.swiper-container', {
      // Optional parameters
      //direction: 'vertical',
      loop: true,
      spaceBetween: 40,
      speed: 1000,
      //autoplay: 5500,
      // slidesPerView: 'auto',
      // centeredSlides: true,

      // If we need pagination
      pagination: '.swiper-pagination',
      paginationClickable: true,

      // Navigation arrows
      nextButton: '.swiper-button-next',
      prevButton: '.swiper-button-prev',

    });

  }

  // Partners

  function partners() {
    $(function() {
    $('.partners .partner img').each(function() {
      var $img = $(this);
      var image = new Image();
      var width, height;
      image.onload = function() {
        console.log('va');
        width = this.width;
        height = this.height;
        $img.css({
          height: width > height ? 'auto' : '150px',
          width: width > height ? '210px' : 'auto'
        });
      };
      image.src = this.src;
    });
  });
  }

  // Masonry

  function initMasonry(){
    $('.masonry-grid').masonry({
      // options
      itemSelector: '.grid-item',
      // use element for option
      columnWidth: '.grid-item',
      percentPosition: true
    });
  }

  // Map

  var MAP = (function() {
    var pub = {};

    var options = {
      zoom: 15,
      scrollwheel: false  ,
      streetViewControl: true,
      mapTypeControl: false,
      draggable: false,
      styles: [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}]
    };

    pub.init = function() {
      $('.map-canvas').each(function() {
        var latitude = $(this).data('lat');
        var longitude = $(this).data('long');
        var map = new google.maps.Map(this, options);
        var bound = new google.maps.LatLngBounds();
        var location = new google.maps.LatLng(latitude, longitude);
        bound.extend(location);
        new google.maps.Marker({
          position: location,
          map: map
        });
        map.setCenter(bound.getCenter());
      });
    };

    return pub;
  }());

})(jQuery); // Fully reference jQuery after this point.
